import { useFeatureStatus } from "portal-ui-remote/FeatureStatusContext";
import React, { lazy } from "react";

import ErrorBoundary from "components/ErrorBoundary/ErrorBoundary";
import Page from "components/Page";
import PageLoadingSkeleton from "components/PageLoadingSkeleton";
import { ProductView } from "components/ProductView";

const RemoteProductsApp = lazy(() => import("codat-products-ui/Products"));

const Products = () => {
  const { featureStatus } = useFeatureStatus();
  const showNewOnboarding = featureStatus?.["PortalUI.NewOnboardingFlow"];
  return (
    <Page>
      {showNewOnboarding ? (
        <ProductView />
      ) : (
        <React.Suspense fallback={<PageLoadingSkeleton />}>
          <ErrorBoundary>
            <RemoteProductsApp />
          </ErrorBoundary>
        </React.Suspense>
      )}
    </Page>
  );
};

export default Products;
